import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = ["placeholder", "aria-label", "data-fehlermeldung"]
const _hoisted_2 = ["required", "aria-required"]
const _hoisted_3 = ["required", "aria-required"]
const _hoisted_4 = ["required", "aria-required"]
const _hoisted_5 = ["required", "aria-required"]
const _hoisted_6 = ["required", "aria-required"]
const _hoisted_7 = { class: "o-grid__cell o-grid__cell--12 u-text-align-right" }
const _hoisted_8 = { class: "o-grid" }
const _hoisted_9 = { class: "o-grid__cell o-grid__cell--6 form-actions u-mar-b-0 u-text-align-left" }
const _hoisted_10 = { class: "o-grid__cell o-grid__cell--6 form-actions u-mar-b-0 u-text-align-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_Anrede = _resolveComponent("Anrede")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_verwalter = _resolveComponent("verwalter")!
  const _component_adresse = _resolveComponent("adresse")!
  const _component_info_box = _resolveComponent("info-box")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ueberschrift, {
      titel: _ctx.piniaStore.state.isMakler ? 'Antragsteller' : 'Ihre persönlichen Angaben'
    }, null, 8, ["titel"]),
    (!_ctx.blendeAnredeaus)
      ? (_openBlock(), _createBlock(_component_zeile, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_titel_zelle, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.wegAnredeErlaubt(_ctx.piniaStore.state) ||
        _ctx.etgAnredeErlaubt(_ctx.piniaStore.state) ||
        _ctx.firmaAnredeErlaubt(_ctx.piniaStore.state, false)
          ? "Versicherungsnehmer"
          : "Anrede und Titel"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_zelle, {
              breite: _ctx.etgAnredeErlaubt(_ctx.piniaStore.state) || _ctx.wegAnredeErlaubt(_ctx.piniaStore.state) ? 4 : 3
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Anrede, {
                  id: "persSalutation",
                  fehler: _ctx.fehler,
                  modelValue: _ctx.piniaStore.state.personendaten.versicherungsnehmer.anrede,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.anrede) = $event)),
                  required: true,
                  ariaRequired: "true",
                  ariaLabel: "Anrede"
                }, null, 8, ["fehler", "modelValue"])
              ]),
              _: 1
            }, 8, ["breite"]),
            (!_ctx.isOrganisation)
              ? (_openBlock(), _createBlock(_component_zelle, {
                  key: 0,
                  breite: _ctx.etgAnredeErlaubt(_ctx.piniaStore.state) || _ctx.wegAnredeErlaubt(_ctx.piniaStore.state) ? 2 : 3
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("select", {
                      id: "persTitle",
                      name: "persTitle",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.titel) = $event)),
                      class: "c-form-control-select",
                      "data-cy": "versicherungsnehmerTitel",
                      "aria-label": "Titel"
                    }, _cache[27] || (_cache[27] = [
                      _createElementVNode("option", { value: "" }, "Titel", -1),
                      _createElementVNode("option", { value: "Dipl.Ing." }, "Dipl. Ing.", -1),
                      _createElementVNode("option", { value: "Dr." }, "Dr.", -1),
                      _createElementVNode("option", { value: "Prof.Dr." }, "Prof. Dr.", -1)
                    ]), 512), [
                      [_vModelSelect, _ctx.piniaStore.state.personendaten.versicherungsnehmer.titel]
                    ]),
                    _createVNode(_component_validierungs_fehler, {
                      "fehler-text": _ctx.fehler.persTitle,
                      "reduzierter-abstand": true
                    }, null, 8, ["fehler-text"])
                  ]),
                  _: 1
                }, 8, ["breite"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isOrganisation)
      ? (_openBlock(), _createBlock(_component_zeile, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_titel_zelle, null, {
              default: _withCtx(() => [
                _createTextVNode("Name der " + _toDisplayString(_ctx.labelOrganisation), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_zelle, { breite: 6 }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "organisation",
                  name: "organisation",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.organisation) = $event)),
                  class: "c-form-control__input",
                  "data-cy": "versicherungsnehmerOrganisation",
                  placeholder: _ctx.labelOrganisation,
                  minlength: "2",
                  maxlength: "40",
                  required: "",
                  "aria-required": "true",
                  "aria-label": _ctx.labelOrganisation,
                  "data-fehlermeldung": 'Bitte geben Sie den Namen der ' + _ctx.labelOrganisation + ' ein (2-40 Zeichen).'
                }, null, 8, _hoisted_1), [
                  [
                    _vModelText,
                    _ctx.piniaStore.state.personendaten.versicherungsnehmer.organisation,
                    void 0,
                    {
                      lazy: true,
                      trim: true
                    }
                  ]
                ]),
                _createVNode(_component_validierungs_fehler, {
                  "fehler-text": _ctx.fehler.organisation
                }, null, 8, ["fehler-text"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.zeigeWegNameHinweis)
      ? (_openBlock(), _createBlock(_component_zeile, { key: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_titel_zelle),
            _createVNode(_component_zelle, { breite: 6 }, {
              default: _withCtx(() => _cache[28] || (_cache[28] = [
                _createElementVNode("div", null, "Im Falle einer Wohnungseigentümergemeinschaft (WEG) muss diese der Versicherungsnehmer sein.", -1)
              ])),
              _: 1,
              __: [28]
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isEtgWeg)
      ? (_openBlock(), _createBlock(_component_verwalter, {
          key: 3,
          fehler: _ctx.fehler,
          ref: "etgWegVerwalterRef"
        }, null, 8, ["fehler"]))
      : _createCommentVNode("", true),
    (!_ctx.isEtgWeg)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          _createVNode(_component_zeile, null, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => [
                  _cache[29] || (_cache[29] = _createTextVNode("Vorname und Name ")),
                  (_ctx.isFirma)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" (optional)")
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 1,
                __: [29]
              }),
              _createVNode(_component_zelle, { breite: 3 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "persFirstName",
                    name: "persFirstName",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.vorname) = $event)),
                    class: "c-form-control__input",
                    "data-cy": "versicherungsnehmerVorname",
                    placeholder: "Vorname",
                    minlength: "2",
                    maxlength: "40",
                    required: !_ctx.isFirma,
                    "aria-required": !_ctx.isFirma,
                    "aria-label": "Vorname",
                    "data-fehlermeldung": "Bitte geben Sie Ihren Vornamen ein (2-40 Zeichen)."
                  }, null, 8, _hoisted_2), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.personendaten.versicherungsnehmer.vorname,
                      void 0,
                      {
                        lazy: true,
                        trim: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.persFirstName
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              }),
              _createVNode(_component_zelle, { breite: 3 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "persLastName",
                    name: "persLastName",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.nachname) = $event)),
                    class: "c-form-control__input",
                    "data-cy": "versicherungsnehmerNachname",
                    placeholder: "Name",
                    minlength: "2",
                    maxlength: "40",
                    required: !_ctx.isFirma,
                    "aria-required": !_ctx.isFirma,
                    "aria-label": "Nachname",
                    "data-parsley-combined-name-length": "40",
                    "data-fehlermeldung": "Bitte geben\n        Sie Ihren Nachnamen ein (2-40 Zeichen)."
                  }, null, 8, _hoisted_3), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.personendaten.versicherungsnehmer.nachname,
                      void 0,
                      {
                        lazy: true,
                        trim: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.persLastName
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (!_ctx.isFirma && !(_ctx.piniaStore.state.verkaufsprodukt === 'PHV' && !_ctx.piniaStore.state.isMakler))
            ? (_openBlock(), _createBlock(_component_zeile, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, null, {
                    default: _withCtx(() => _cache[30] || (_cache[30] = [
                      _createTextVNode("Geburtsdatum")
                    ])),
                    _: 1,
                    __: [30]
                  }),
                  _createVNode(_component_zelle, { breite: 3 }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "date",
                        id: "geburtsdatum",
                        name: "geburtsdatum",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.geburtsdatum) = $event)),
                        onFocus: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onGeburtsdatumFocus && _ctx.onGeburtsdatumFocus(...args))),
                        onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onGeburtsdatumBlur && _ctx.onGeburtsdatumBlur(...args))),
                        class: "c-form-control__input",
                        placeholder: "TT.MM.JJJJ",
                        title: "Geburtsdatum im Format TT.MM.JJJJ",
                        required: !_ctx.isFirma,
                        "aria-required": !_ctx.isFirma,
                        "aria-label": "Geburtsdatum im Format TT.MM.JJJJ",
                        "data-checkalter18bis100": "true",
                        "data-cy": "versicherungsnehmerGeburtstag"
                      }, null, 40, _hoisted_4), [
                        [
                          _vModelText,
                          _ctx.piniaStore.state.personendaten.versicherungsnehmer.geburtsdatum,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.geburtsdatum
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.piniaStore.state.verkaufsprodukt !== 'VGV')
            ? (_openBlock(), _createBlock(_component_adresse, {
                key: 1,
                fehler: _ctx.fehler,
                plz: _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.plz,
                "onUpdate:plz": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.plz) = $event)),
                ort: _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.ort,
                "onUpdate:ort": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.ort) = $event)),
                strasse: _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.strasse,
                "onUpdate:strasse": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.strasse) = $event)),
                hausnummer: _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.hausnummer,
                "onUpdate:hausnummer": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.hausnummer) = $event)),
                "zu-pruefen": _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.zuPruefen,
                "onUpdate:zuPruefen": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.zuPruefen) = $event)),
                feldNamen: {
        plz: 'versicherungsnehmerPlz',
        ort: 'versicherungsnehmerOrt',
        strasse: 'versicherungsnehmerStrasse',
        hausnummer: 'versicherungsnehmerHausnummer',
      },
                "deaktivierte-felder": _ctx.deaktivierteFelderFuerSparte,
                "session-marker": "versicherungsnehmer",
                ref: "versicherungsnehmerAdresseRef"
              }, null, 8, ["fehler", "plz", "ort", "strasse", "hausnummer", "zu-pruefen", "deaktivierte-felder"]))
            : _createCommentVNode("", true),
          _createVNode(_component_zeile, null, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => [
                  _createTextVNode("E-Mail " + _toDisplayString(_ctx.piniaStore.state.isMakler && !_ctx.kundeMoechteVertragsuterlagenDigital() ? "(optional) " : ""), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_zelle, null, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    id: "persEmail",
                    name: "persEmail",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.email) = $event)),
                    class: "c-form-control__input",
                    "data-cy": "versicherungsnehmerEmail",
                    placeholder: "E-Mail",
                    minlength: "2",
                    maxlength: "60",
                    required: !_ctx.piniaStore.state.isMakler || _ctx.kundeMoechteVertragsuterlagenDigital(),
                    "aria-required": !_ctx.piniaStore.state.isMakler || _ctx.kundeMoechteVertragsuterlagenDigital(),
                    "aria-label": "Email des Versicherungsnehmers",
                    "data-fehlermeldung": "Bitte geben Sie Ihre E-Mail-Adresse ein (2-60 Zeichen)."
                  }, null, 8, _hoisted_5), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.personendaten.versicherungsnehmer.email,
                      void 0,
                      {
                        lazy: true,
                        trim: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.persEmail
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_zeile, null, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                "zeige-info": !_ctx.piniaStore.state.isMakler,
                "info-box-id": "persTelefonInfo"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Telefon " + _toDisplayString(_ctx.piniaStore.state.isMakler === true ? "(optional) " : ""), 1)
                ]),
                _: 1
              }, 8, ["zeige-info"]),
              _createVNode(_component_zelle, null, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "persPhone",
                    name: "persPhone",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.telefon) = $event)),
                    class: "c-form-control__input",
                    placeholder: "Telefon",
                    "data-cy": "versicherungsnehmerTelefon",
                    minlength: "6",
                    maxlength: "30",
                    required: _ctx.eineTelefonnummerMussAngegebenWerden,
                    "aria-required": _ctx.eineTelefonnummerMussAngegebenWerden,
                    "aria-label": "Telefonnummer des Versicherungsnehmers",
                    "data-checktelefonnummer": "true"
                  }, null, 8, _hoisted_6), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.personendaten.versicherungsnehmer.telefon,
                      void 0,
                      {
                        lazy: true,
                        trim: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.persPhone
                  }, null, 8, ["fehler-text"]),
                  _createVNode(_component_info_box, { id: "persTelefonInfo" }, {
                    default: _withCtx(() => _cache[31] || (_cache[31] = [
                      _createTextVNode(" Bitte geben Sie die Telefonnummer an, unter der Sie tagsüber erreichbar sind. Ihre Daten werden nicht zu Werbezwecken verwendet, sondern lediglich für Rückfragen unserer Mitarbeiter/innen genutzt. ")
                    ])),
                    _: 1,
                    __: [31]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_zeile, null, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                "zeige-info": !_ctx.piniaStore.state.isMakler,
                "info-box-id": "persMobilInfo"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Mobiltelefon " + _toDisplayString(_ctx.piniaStore.state.isMakler === true ? "(optional) " : ""), 1)
                ]),
                _: 1
              }, 8, ["zeige-info"]),
              _createVNode(_component_zelle, null, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "persMobile",
                    name: "persMobile",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.mobil) = $event)),
                    class: "c-form-control__input",
                    "data-cy": "versicherungsnehmerMobil",
                    placeholder: "Mobiltelefon",
                    minlength: "6",
                    maxlength: "30",
                    "aria-label": "Mobilrufnummer des Versicherungsnehmers",
                    "data-checkmobilnummer": "true"
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.personendaten.versicherungsnehmer.mobil,
                      void 0,
                      {
                        lazy: true,
                        trim: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.persMobile
                  }, null, 8, ["fehler-text"]),
                  _createVNode(_component_info_box, { id: "persMobilInfo" }, {
                    default: _withCtx(() => _cache[32] || (_cache[32] = [
                      _createTextVNode(" Ihre Mobilnummer wird nicht zu Werbezwecken verwendet, sondern lediglich für Rückfragen unserer Mitarbeiter/innen genutzt. ")
                    ])),
                    _: 1,
                    __: [32]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.verwalterFrageIstSichtbar)
            ? (_openBlock(), _createBlock(_component_zeile, {
                key: 2,
                "spacing-y": false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, null, {
                    default: _withCtx(() => _cache[33] || (_cache[33] = [
                      _createTextVNode("Abweichender Ansprechpartner/Verwalter")
                    ])),
                    _: 1,
                    __: [33]
                  }),
                  _createVNode(_component_zelle, { class: "mkRadio" }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalterAktiv) = $event)),
                        type: "radio",
                        id: "verwalterAktivNein",
                        name: "verwalterAktiv",
                        value: false,
                        "data-cy": "verwalterAktivFalse",
                        required: "",
                        "aria-required": "true",
                        "aria-label": "Nein, es gibt keinen abweichenden Ansprechpartner/Verwalter",
                        "data-fehlermeldung": "Bitte treffen Sie eine Auswahl."
                      }, null, 512), [
                        [_vModelRadio, _ctx.piniaStore.state.personendaten.verwalterAktiv]
                      ]),
                      _cache[34] || (_cache[34] = _createElementVNode("label", {
                        for: "verwalterAktivNein",
                        class: "radiolabel"
                      }, "Nein", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.piniaStore.state.personendaten.verwalterAktiv) = $event)),
                        type: "radio",
                        id: "verwalterAktivJa",
                        name: "verwalterAktiv",
                        value: true,
                        "aria-label": "Ja, es gibt einen abweichenden Ansprechpartner/Verwalter",
                        "data-cy": "verwalterAktivTrue"
                      }, null, 512), [
                        [_vModelRadio, _ctx.piniaStore.state.personendaten.verwalterAktiv]
                      ]),
                      _cache[35] || (_cache[35] = _createElementVNode("label", {
                        for: "verwalterAktivJa",
                        class: "radiolabel"
                      }, " Ja", -1)),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.verwalterAktiv,
                        "reduzierter-abstand": true
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1,
                    __: [34,35]
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.piniaStore.state.personendaten.verwalterAktiv)
            ? (_openBlock(), _createBlock(_component_verwalter, {
                key: 3,
                fehler: _ctx.fehler,
                ref: "verwalterRef"
              }, null, 8, ["fehler"]))
            : _createCommentVNode("", true),
          (_ctx.piniaStore.state.verkaufsprodukt === 'VGV' && !_ctx.piniaStore.state.personendaten.verwalterAktiv)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _createVNode(_component_zeile, { "spacing-y": false }, {
                  default: _withCtx(() => [
                    _createVNode(_component_titel_zelle, null, {
                      default: _withCtx(() => _cache[36] || (_cache[36] = [
                        _createTextVNode("Abweichende Postanschrift")
                      ])),
                      _: 1,
                      __: [36]
                    }),
                    _createVNode(_component_zelle, { class: "mkRadio" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresseAbweichendVonRisikoadresse) = $event)),
                          type: "radio",
                          id: "adresseAbweichendVonRisikoadresseNein",
                          name: "adresseAbweichendVonRisikoadresse",
                          value: false,
                          "data-cy": "adresseAbweichendVonRisikoadresseFalse",
                          required: "",
                          "data-fehlermeldung": "Bitte wählen Sie eine Zahlart aus."
                        }, null, 512), [
                          [_vModelRadio, _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresseAbweichendVonRisikoadresse]
                        ]),
                        _cache[37] || (_cache[37] = _createElementVNode("label", {
                          for: "adresseAbweichendVonRisikoadresseNein",
                          class: "radiolabel"
                        }, "Nein", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresseAbweichendVonRisikoadresse) = $event)),
                          type: "radio",
                          id: "adresseAbweichendVonRisikoadresseJa",
                          name: "adresseAbweichendVonRisikoadresse",
                          value: true,
                          "data-cy": "adresseAbweichendVonRisikoadresseTrue"
                        }, null, 512), [
                          [_vModelRadio, _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresseAbweichendVonRisikoadresse]
                        ]),
                        _cache[38] || (_cache[38] = _createElementVNode("label", {
                          for: "adresseAbweichendVonRisikoadresseJa",
                          class: "radiolabel"
                        }, "Ja", -1)),
                        _createVNode(_component_validierungs_fehler, {
                          "fehler-text": _ctx.fehler.adresseAbweichendVonRisikoadresse,
                          "reduzierter-abstand": true
                        }, null, 8, ["fehler-text"])
                      ]),
                      _: 1,
                      __: [37,38]
                    })
                  ]),
                  _: 1
                }),
                (_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresseAbweichendVonRisikoadresse)
                  ? (_openBlock(), _createBlock(_component_adresse, {
                      key: 0,
                      fehler: _ctx.fehler,
                      plz: _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.plz,
                      "onUpdate:plz": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.plz) = $event)),
                      ort: _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.ort,
                      "onUpdate:ort": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.ort) = $event)),
                      strasse: _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.strasse,
                      "onUpdate:strasse": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.strasse) = $event)),
                      hausnummer: _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.hausnummer,
                      "onUpdate:hausnummer": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.hausnummer) = $event)),
                      "zu-pruefen": _ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.zuPruefen,
                      "onUpdate:zuPruefen": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.piniaStore.state.personendaten.versicherungsnehmer.adresse.zuPruefen) = $event)),
                      feldNamen: {
          plz: 'abweichendePlz',
          ort: 'abweichenderOrt',
          strasse: 'abweichendeStrasse',
          hausnummer: 'abweichendeHausnummer',
        },
                      "session-marker": "versicherungsnehmer",
                      ref: "versicherungsnehmerAdresseAbweichendVonRisikoadresseRef"
                    }, null, 8, ["fehler", "plz", "ort", "strasse", "hausnummer", "zu-pruefen"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.zeigeTarifwechselOption)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 5,
          onCloseModal: _ctx.onCloseModal,
          titel: "Wohnungseigentümergemeinschaft (WEG)",
          text: "Für Wohnungseigentümergemeinschaften haben wir spezielle Tarife. Die entsprechende Auswahl können Sie auf Schritt 1 treffen."
        }, {
          inhalt: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    class: "c-button c-button--inverted",
                    type: "button",
                    onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.onCloseModal && _ctx.onCloseModal(...args)))
                  }, "Abbrechen")
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    class: "c-button right",
                    type: "button",
                    onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.onChangeTarif && _ctx.onChangeTarif(...args)))
                  }, "WEG-Tarif auf Schritt 1 wählen")
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onCloseModal"]))
      : _createCommentVNode("", true)
  ], 64))
}